import React, { Suspense, useEffect, useState } from "react";
import {  Box, Button, CircularProgress,  Divider,  useTheme  } from "@mui/material";
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import apiInstance from "../../services/ServiceApi";
import BuscarCliente from "../../components/agent/cliente/BuscarCliente";
import AlertModal from "../../components/utilities/AlertModal";
import HistoricoGestionStats from "../../components/agent/historico/HistoricoGestionStats";
import ModalEnviarMensaje from "../../components/sms/SendSMS";

const Cliente = React.lazy(() => import('../../components/agent/cliente/Cliente'));
const HistoricoGestiones = React.lazy(() => import('../../components/agent/historico/HistoricoGestiones'));
const Cuentas = React.lazy(() => import('../../components/agent/cuenta/CuentasVentas'));
const MemoizedCuentas = React.memo(Cuentas);

const GestionCobranza = () => {
  const theme = useTheme();
  const location = useLocation();
  const [modalSearchOpen, setModalSearchOpen] = useState(false);
  const [elapsedTime, setElapsedTime] = useState(0);
  const [campaignDiscadorExists, setCampaignDiscadorExists] = useState(false);
  const [lineaNegocio, setLineaNegocio] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalSMS, setModalSMS] = useState(false);
  const handleCloseModalAlert = () => {    setModalOpen(false); };
  const parsed = queryString.parse(location.search);
  const uniqueid = parsed.uniqueid || parsed.callid || -1;
  const campaign = parsed.campaign;
  const user = parsed.user;
  const phone_number = parsed.phone_number;
  const [idCliente, setIdCliente] = useState(null);
  const [vendorId, setVendorId] = useState(parsed.vendor_id);
  const [reloadHistorico, setReloadHistorico] = useState(false);

  const handleHistorico = (shouldReload) => {
    if (shouldReload) {
      setReloadHistorico(prev => !prev);  // Cambia el estado para forzar la recarga
      setVendorId(null)
        setCampaignDiscadorExists(false);  
    }
  };
  const manejarIdCliente = (idCliente) => {
    setIdCliente(idCliente);
  };
  const handleSelectClient = (id) => {
    setVendorId(id);
    setModalSearchOpen(false);
  }
 
  useEffect(() => {
      if (campaign) {
        apiInstance.get('/campania/', {params:{ campania: campaign} })
          .then(response => {
              setCampaignDiscadorExists(true);  
              setLineaNegocio(response.data.linea_negocio);
              setModalOpen(false)
          
          })
          .catch(error => {
            setCampaignDiscadorExists(false);
            setModalOpen(true)
          });
      }
    }, [campaign,vendorId]);

    return (
      <Box sx={{ flexGrow: 1, padding: 2, mx: [1, 2, 3], bgcolor: theme.palette.background.default }}>
        <Button variant="contained" color="success" onClick={() => setModalSearchOpen(true)}>Buscar Cliente</Button>
        {lineaNegocio && lineaNegocio.sent_sms && <Button variant="contained" color="primary" onClick={() => setModalSMS(true)}>Enviar Mensaje</Button>}
        {modalSearchOpen && (
          <BuscarCliente
            open={modalSearchOpen}
            onClose={() => setModalSearchOpen(false)}
            idLineaNegocio={lineaNegocio.id}
            onSelectClient={handleSelectClient}
            lineaNegocio ={lineaNegocio}
          />
        )}
        {idCliente && modalSMS && (
          <ModalEnviarMensaje
            telefono={phone_number}
            onClose={() => setModalSMS(false)}
            cliente_id = {idCliente}
            onSelectClient={handleSelectClient}
            codigo_llamada={uniqueid}
          />
        )}
        
        {campaignDiscadorExists ? (
          <>
            <HistoricoGestionStats codigo_usuario={user} idLineaNegocio={lineaNegocio.id} />
            <Suspense fallback={<CircularProgress />}>
              <Cliente identificador={vendorId} lineaNegocio={lineaNegocio} manejarIdCliente={manejarIdCliente} campania={campaign} codigo_usuario={user}/>
            </Suspense>
            {idCliente && lineaNegocio && (
              <>
              <Suspense fallback={<CircularProgress />}>
                <MemoizedCuentas
                  identificador={vendorId}
                  id_linea_negocio={lineaNegocio.id}
                  codigo_llamada={uniqueid}
                  codigo_usuario={user}
                  numero_contactado={phone_number}
                  campaign={campaign}
                  idCliente={idCliente}
                  callBackHistorico={handleHistorico}
                  formulario={lineaNegocio.formulario}

                />
              </Suspense>
              <Box my={1}>  
                    <Divider sx={{ padding: '2' }} />
                </Box>

              <Suspense fallback={<CircularProgress />}>
                    <Box mb={2}>
                        <HistoricoGestiones id_cliente={idCliente} reload={reloadHistorico} codigo_usuario={user} linea_negocio_id={lineaNegocio.id}/>
                    </Box>
                </Suspense>
            </> )}
          </>
        ) : (
            <AlertModal
              open={modalOpen}
              onClose={handleCloseModalAlert}
              alertType={'error'}
              message={`No se encontró la campaña ${campaign}`}
            />
        )}
      </Box>
    );
  };
  
  export default GestionCobranza;